import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { InfoIcon } from '../../icons';
import { Popover } from '@material-ui/core';
import { VcStatusPopup } from '..';

const VcStatusIndicator = ({
  rowData,
  fontSize = '1.5em',
  style: infoIconStyle = {},
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const iconRef = useRef(null);

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  const redColor = '#F17C7C';

  const fillColor = redColor;

  return (
    <>
      <InfoIcon
        style={{
          color: fillColor,
          fontSize,
          height: fontSize,
          width: fontSize,
          ...infoIconStyle,
        }}
        ref={iconRef}
        onClick={openPopup}
      />

      <Popover
        open={isPopupOpen}
        anchorEl={iconRef.current}
        onClose={closePopup}
        anchorOrigin={{
          vertical: 'right',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'left',
          horizontal: 'left',
        }}
      >
        <VcStatusPopup asn={{ ...rowData, status: rowData.vcStatus }} />
      </Popover>
    </>
  );
};

VcStatusIndicator.propTypes = {
  rowData: PropTypes.object.isRequired,
  fontSize: PropTypes.string,
  style: PropTypes.object,
};

export default VcStatusIndicator;
